import { LightningBoltCircleIcon } from './LightningBoltCircleIcon';

/**
 * author: Google
 * id F055DA49-5992-4DDC-8C71-E5D331520DEA
 * name lightning-bolt-circle
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightning-bolt-circle.svg
 * tags
 * - Home Automation 
 * - Weather 
 */
export const ElectricityCircleIcon = LightningBoltCircleIcon;
export default ElectricityCircleIcon